// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-tertiary-button-e5daf93f"};